import React, { useEffect, useRef } from "react"
import anime from "animejs"
import classNames from "classnames"
import { motion, usePresence } from "motion/react"

import { sleep } from "@/topic/rogue_5/utils/misc"
import { EGameScene, useGameStore } from "../../store"

import treeLeftPng from "../../../../assets/img/game/loading/tree-left.png"
import treeLeftWebP from "../../../../assets/img/game/loading/tree-left.webp"
import treeRightPng from "../../../../assets/img/game/loading/tree-right.png"
import treeRightWebP from "../../../../assets/img/game/loading/tree-right.webp"
import styles from "./index.module.less"

const basic_front_in_animation = {
    opacity: [0, 1],
    filter: ["blur(10px)", "blur(0px)"],
    scale: [0.8, 1],
    duration: 1500,
    easing: "easeOutCubic",
}

function getTreeAnimate(left: boolean) {
    return {
        translateX: [left ? "15vw" : "-15vw", 0],
        ...basic_front_in_animation,
    }
}

const basic_out_animation = {
    opacity: [1, 0],
    // translateX: ["0", "-40vw"],
    duration: 600,
    easing: "easeInCubic",
}

const basic_blur_animation = {
    filter: ["blur(0px)", "blur(10px)"],
    scale: [1, 1.1],
    duration: 800,
    easing: "easeInCubic",
}

const SCENE_ANIMATION = {
    animate: async (container: HTMLDivElement) => {
        const treeLeft = container.querySelector(`.${styles.treeLeft}`)
        const treeRight = container.querySelector(`.${styles.treeRight}`)
        const ticket = container.querySelector(`.${styles.ticket}`)
        const timeline = anime.timeline()
        timeline.add({ targets: treeLeft, ...getTreeAnimate(true) }, 0)
        timeline.add({ targets: treeRight, ...getTreeAnimate(false) }, 0)
        timeline.add(
            {
                targets: ticket,
                ...basic_front_in_animation,
                scale: [0.6, 1],
            },
            0
        )
        return timeline.finished
    },
    exit: async (container: HTMLDivElement) => {
        // const treeLeft = container.querySelector(`.${styles.treeLeft}`)
        // const treeRight = container.querySelector(`.${styles.treeRight}`)
        // const ticket = container.querySelector(`.${styles.ticket}`)
        const timeline = anime.timeline()
        // timeline.add({ targets: treeLeft, ...basic_out_animation }, 0)
        // timeline.add({ targets: treeRight, ...basic_out_animation }, 0)
        // timeline.add({ targets: ticket, ...basic_out_animation }, 0)
        timeline.add({ targets: container, ...basic_out_animation }, 200)
        timeline.add({ targets: container, ...basic_blur_animation }, 0)
        return timeline.finished.then(() => sleep(300))
    },
}

const GameSceneLoading: React.FC<{
    className?: string
    style?: React.CSSProperties
}> = ({ className, style }) => {
    const { setScene } = useGameStore()

    // animation
    const [isPresent, safeToRemove] = usePresence()
    const containerRef = useRef<HTMLDivElement>(null)
    useEffect(() => {
        if (!containerRef.current) return
        if (isPresent) {
            SCENE_ANIMATION.animate(containerRef.current)
                .then(() => sleep(400))
                .then(() => {
                    setScene(EGameScene.Lobby)
                })
        } else {
            SCENE_ANIMATION.exit(containerRef.current).then(() => {
                safeToRemove()
            })
        }
    }, [isPresent])

    // logic
    return (
        <motion.div
            ref={containerRef}
            className={classNames(styles.sceneContainer, className)}
            style={style}
            // onClick={() => setScene(EGameScene.Lobby)}
            initial="initial"
            animate={isPresent ? "animate" : "exit"}
        >
            <div className={styles.ticket} />
            <div className={styles.treeLeft}>
                <picture>
                    <source srcSet={treeLeftWebP} type="image/webp" />
                    <img src={treeLeftPng} alt="tree-left" />
                </picture>
            </div>
            <div className={styles.treeRight}>
                <picture>
                    <source srcSet={treeRightWebP} type="image/webp" />
                    <img src={treeRightPng} alt="tree-right" />
                </picture>
            </div>
        </motion.div>
    )
}

export default GameSceneLoading
